// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__lJi76","icon":"HeaderCartButton_icon__UDGUD","badge":"HeaderCartButton_badge__lig2+","bump":"HeaderCartButton_bump__SXE7L"};